import { render, staticRenderFns } from "./OfferingTable.vue?vue&type=template&id=d2667e38&scoped=true"
import script from "./OfferingTable.vue?vue&type=script&lang=js"
export * from "./OfferingTable.vue?vue&type=script&lang=js"
import style0 from "./OfferingTable.vue?vue&type=style&index=0&id=d2667e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2667e38",
  null
  
)

export default component.exports